export default __webpack_public_path__ + "static/media/Artwork_gmx.bb59236f.svg";